import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center grain px-4">
      <div className="bg-white border border-slate-200 rounded-3xl paper-shadow p-10 max-w-md w-full text-center" data-testid="payment-cancel-page">
        <div className="h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center mx-auto">
          <XCircle className="h-9 w-9 text-slate-400" />
        </div>
        <h1 className="font-display text-2xl font-bold mt-5">Checkout cancelled</h1>
        <p className="text-slate-500 mt-2">No charge was made. You can top up whenever you're ready.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Link to="/buy-credits"><Button className="bg-indigo-600 hover:bg-indigo-700 text-white rounded-full">Back to packs</Button></Link>
          <Link to="/studio"><Button variant="outline" className="rounded-full">Go to Studio</Button></Link>
        </div>
      </div>
    </div>
  );
}
